import { render, staticRenderFns } from "./tuya.vue?vue&type=template&id=62949217&scoped=true&"
import script from "./tuya.vue?vue&type=script&lang=js&"
export * from "./tuya.vue?vue&type=script&lang=js&"
import style0 from "./tuya.vue?vue&type=style&index=0&id=62949217&scoped=true&lang=css&"
import style1 from "./tuya.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62949217",
  null
  
)

export default component.exports